import { createApp } from 'vue';
import EpubToAzw3Converter from '@/Components/EpubToAzw3Converter.vue';
import '@styles/app.css';

createApp(EpubToAzw3Converter).mount('#epub-to-azw3-converter');
